import React from 'react'
import { Link as ReactLink }from 'react-router-dom'
import Link from '@mui/material/Link'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'

export default function EventMobile() {
  return (
    <Box 
        display="flex" 
        flexDirection="column" 
        alignItems="center" 
        justifyContent="column" 
        // sx={{ p: 10}}
        // style={{ width:'100%', height: '100vh' }}
    >
        <Box
            display="flex" 
            flexDirection="column" 
            alignItems="left" 
            // justifyContent="flex-start" 
            sx={{ p: 3 }}
            style={{ width: '100%', height: '201px', backgroundImage: 'url("/images/events/banner_top_m.jpg")', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}
        >
            <ReactLink to='/'>
                <Box style={{ paddingBottom: '60px' }}>
                    <img alt="logo" src="/images/events/home_m.png" />
                </Box>
            </ReactLink>
            <Box display="flex" flexDirection="row" alignItems="center" justifyContent="left" >
                <span style={{color: 'white', fontSize: '16px', paddingRight: '10px'}}>Nice to meet u,</span>
                <img height="20px" alt="logo" src="/images/events/logo_white_m.png" />
            </Box>
            <span style={{ color: 'white', fontSize: '41px', fontWeight: "bold" }}>스타터 작가</span>

        </Box>
        <Box
            display="flex" 
            flexDirection="column" 
            sx={{ m: 5 }} 
        >
            <Box 
                display="flex" 
                flexDirection="column" 
                alignItems="center" 
                justifyContent="center" 
                style={{ width: '367px', height: '117px', backgroundImage: 'url("/images/events/banner_top2_m.jpg")', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}
            >
                <img alt="logo" src="/images/events/logo_square_white_m.png" />
            </Box>
        </Box>
        <Box
            display="flex" 
            flexDirection="column" 
            alignItems="center" 
            justifyContent="center" 
            sx={{ pt: 5 }}
        >
            <span style={{ fontSize: '18px', paddingBottom: '5px' }}>Welcome, MOOA!</span>
            <span style={{ fontSize: '23px', fontWeight: "bold", }}>스타터 작가란 무엇인가요?</span>
            <span style={{ fontSize: '16px', paddingTop: '20px', paddingBottom: '5px' }}>모아의 시작을 함께 할 작가들을 뜻합니다.</span>
            <span style={{ fontSize: '16px', paddingBottom: '5px' }}>모아 출시와 동시에 작품이 업로드되고,</span>
            <span style={{ fontSize: '16px', }}>앱의 메인과 공식 SNS에 소개가 될 예정입니다.</span>

        </Box>
        <Box
            display="flex" 
            flexDirection="column" 
            alignItems="left" 
            justifyContent="center" 
            style={{ backgroundColor: '#F2F2F2', width: '367px', marginTop: '30px', borderRadius: '10px' }}
            sx={{ p: 3 }}
        >
            <Box
                display="flex" 
                flexDirection="row" 
                alignItems="center" 
                justifyContent="left" 
                // sx={{ pl: 40 }}
            >
                <img alt="logo" src="/images/events/number_1_m.png" />
                <span style={{ fontSize: '18px', paddingLeft: '8px', }}>앱 출시일이 언제인가요?</span>
            </Box>
            <Box
                display="flex" 
                flexDirection="column" 
                alignItems="end" 
                justifyContent="center" 
                sx={{ pr: 1 }}
            >
                <span style={{ fontSize: '16px', paddingTop: '20px', }}>- 6월 10일 출시 예정입니다.</span>
                <span style={{ fontSize: '10px', color: '#707070', paddingTop: '5px', paddingBottom: '20px', }}>* 내부 사정에 의해 변동될 수 있습니다</span>
            </Box>
            <Divider sx={{ height: 1.5, marginLeft: '1%', marginRight: '1%' }} orientation="vertical" style={{ background: '#B7B7B7' }} />
            <Box
                display="flex" 
                flexDirection="row" 
                alignItems="center" 
                justifyContent="left" 
                sx={{ pt: 3 }}
            >
                <img alt="logo" src="/images/events/number_1_m.png" />
                <span style={{ fontSize: '18px', paddingLeft: '8px', }}>모집인원이 어떻게 되나요?</span>
            </Box>
            <Box
                display="flex" 
                flexDirection="column" 
                alignItems="end" 
                justifyContent="center" 
                sx={{ pr: 1 }}
            >
                <span style={{ fontSize: '16px', paddingTop: '20px', paddingBottom: '20px', }}>- 50명 내외로 선발될 예정입니다.</span>
            </Box>
            <Divider sx={{ height: 1.5, marginLeft: '1%', marginRight: '1%' }} orientation="vertical" style={{ background: '#B7B7B7' }} />
            <Box
                display="flex" 
                flexDirection="row" 
                alignItems="center" 
                justifyContent="left" 
                sx={{ pt: 3 }}
            >
                <img alt="logo" src="/images/events/number_1_m.png" />
                <span style={{ fontSize: '18px', paddingLeft: '8px', }}>필요한 정보는 어떤게 있나요?</span>
            </Box>
            <Box
                display="flex" 
                flexDirection="column" 
                alignItems="left" 
                justifyContent="center" 
                sx={{ pl: 7 }}
            >
                <Box
                    display="flex" 
                    flexDirection="row" 
                    alignItems="left" 
                    // justifyContent="center" 
                    // sx={{ pr: 1 }}
                >
                    <span style={{ fontSize: '16px', paddingTop: '20px', }}>- 이름, 연락처,</span>
                    <span style={{ fontSize: '16px', color: '#707070', paddingTop: '20px', }}>&nbsp;홍보 희망 계정 (선택)</span>
                </Box>
                <span style={{ fontSize: '16px', paddingTop: '5px', }}>- 업로드 희망 작품 정보</span>
                <span style={{ fontSize: '12px', color: '#707070', paddingTop: '5px', }}>[이미지, 작품명, 재료, 작품 규격, 작품 설명, 작품 유형]</span>
            </Box>
        </Box>
        <Box
            display="flex" 
            flexDirection="column" 
            alignItems="center" 
            justifyContent="center" 
            sx={{ pt: 10, mb: 5 }}
        >
            <span style={{ fontSize: '20px', fontWeight: "bold", }}>스타터 작가가 되면...</span>
        </Box>
        <Box
            display="flex" 
            flexDirection="column" 
            alignItems="cnter" 
            justifyContent="center" 
            sx={{ mb: 5 }}
        >
            <img alt="logo" src="/images/events/square_1_m.png" />
            <span style={{ fontSize: '16px', textAlign: 'center', paddingTop: '20px' }}>모아 앱의 메인화면에 소개</span>
        </Box>
        <Box
            display="flex" 
            flexDirection="column" 
            alignItems="cnter" 
            justifyContent="center" 
            sx={{ mb: 5 }}
        >
            <img alt="logo" src="/images/events/square_2_m.png" />
            <span style={{ fontSize: '16px', textAlign: 'center', paddingTop: '20px' }}>인스타 공식 계정에 소개</span>
        </Box>
        <Box
            display="flex" 
            flexDirection="column" 
            alignItems="cnter" 
            justifyContent="center" 
            sx={{ mb: 5 }}
        >
            <img alt="logo" src="/images/events/square_3_m.png" />
            <span style={{ fontSize: '16px', textAlign: 'center', paddingTop: '20px' }}>온·오프라인 전시 우선선정</span>
        </Box>
        <Box
            display="flex" 
            flexDirection="column" 
            alignItems="cnter" 
            justifyContent="center"
            sx={{ mb: 7 }}
        >
            <img alt="logo" src="/images/events/square_4_m.png" />
            <span style={{ fontSize: '16px', textAlign: 'center', paddingTop: '20px' }}>5만원・ 3만원・ 1만원 상품권 증정</span>
        </Box>
        <Link href="https://forms.gle/TtvW3akmdGNaDNpi6/" target='_blank' style={{ textDecoration: 'none', color: 'black' }}>
            <Box
                display="flex" 
                flexDirection="row" 
                alignItems="center" 
                justifyContent="center" 
                style={{ width: '367px', border: '1px solid black', borderRadius: '50px',}}
                sx={{ p: 3, boxShadow: 3 }}
            >
                <span style={{ fontSize: '20px', fontWeight: 'bold' }}>스타터 작가 신청하러 가기</span>
            </Box>
        </Link>
        <Box 
            style={{ 
            width:'100%', 
            height: '500px',
            backgroundColor: '#353C46',
            marginTop: '100px',
        }}>
            <Box 
                display="flex" 
                flexDirection="row"
                alignItems="center"
                justifyContent="space-between"
                paddingLeft="5%"
                paddingRight="5%"
                paddingTop='50%'
            >
                <img alt="logo" src="/images/mooa_logo_footer_m.png" width={'81'} height={'27'}/>
                <span style={{color: '#ffffff', fontSize: '12px', }}>모두의 아트, 모아</span>
            </Box>
            <Divider sx={{ height: 2, m: 1, marginLeft: '5%', marginRight: '5%' }} orientation="vertical" style={{ background: '#B7B7B7' }} />
            <Box 
                display="flex" 
                flexDirection="column"
                paddingLeft="5%"
                paddingRight="5%"
                paddingTop='20px'
            >
                <span style={{color: '#B7B7B7', fontSize: '12px'}}>문의사항 oursartsmoah@gmail.com</span>
                <span style={{color: '#B7B7B7', fontSize: '12px'}}>서울특별시 금천구 가산디지털1로 205-15, 1007호</span>
                <span style={{color: '#B7B7B7', fontSize: '12px'}}>사업자 등록번호: 515-81-56247 주식회사 러닝포인트</span>
            </Box>
            <Box 
                display="flex" 
                flexDirection="row"
                paddingLeft="3%"
                paddingTop='20px'
            >
                <Link href="https://www.instagram.com/art___mooa/" target='_blank'>
                    <img alt="logo" src="/images/instagram_logo_m.png" width={'30'} height={'28'}/>
                </Link>
            </Box>
            <Box 
                display="flex" 
                flexDirection="row"
                paddingLeft="5%"
                paddingRight="5%"
                paddingTop='10px'
            >
                <span style={{color: '#B7B7B7', fontSize: '12px'}}>©</span>
                <span style={{color: '#B7B7B7', fontSize: '12px', paddingLeft: '5px'}}>MOOA</span>
            </Box>
        </Box>
    </Box>
  )
}
